<template>
  <custom-callout class="provider-proposal-callout">
    <div class="row">
      <div class="col-md-10">
        <div class="row">
          <div class="col-md-3">
            <div class="legend">Número de Propuesta:</div>
            <div
              class="font-weight-normal text-black"
              v-text="data.proposalNumber"
            />
          </div>
          <div class="col-md-3">
            <div class="legend">Tipo de Proveedor:</div>
            <div
              class="font-weight-normal text-black"
              v-text="data.providerType"
            />
          </div>
          <div class="col-md-3">
            <div class="legend">Nombre del Proveedor:</div>
            <div
              class="font-weight-normal text-black"
              v-text="data.providerName"
            />
          </div>
          <div class="col-md-3">
            <div class="legend">Servicio(s) a Ofrecer:</div>
            <div
              v-for="(item, index) in data.services"
              :key="index"
              class="font-weight-normal text-black"
              v-text="item.name"
            />
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="d-flex justify-content-end">
          <action-button
            class="mx-4 px-4 mt-1"
            i="fas fa-check"
            text="Seleccionar"
            variant="outline-success"
            @click="onSelectHandler"
          />
        </div>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import ActionButton from '@/components/common/ActionButton';
import CustomCallout from '@/components/common/CustomCallout';

export default {
  name: 'ProviderSearchResultItem',
  components: {
    ActionButton,
    CustomCallout,
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        id: null,
        proposalNumber: '',
        providerName: '',
        providerType: '',
        services: [],
      }),
      required: true,
    },
  },
  computed: {
    offerServices() {
      return this.data.services.length
        ? this.data.services.map(({ name }) => name).join(', ')
        : '-';
    },
  },
  methods: {
    onSelectHandler() {
      this.$emit('select', this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.provider-proposal-callout ::v-deep .callout-container {
  border: none !important;
  background-color: white;
  padding-left: 25px;
}
.legend {
  font-weight: 400;
}

.text-black {
  color: #11291b;
}
</style>
